







import {
    defineComponent,
    reactive,
    toRefs,
    computed,
    onMounted,
} from '@vue/composition-api';
import { isProduction } from '@/common/consts';

export default defineComponent({
    props: {
        text: String,
        isJumpIndex: {
            type: Boolean,
            default: false,
        },
        type: String,
    },
    setup(props, context) {
        onMounted(() => {
            if (props.isJumpIndex) {
                const url = isProduction
                    ? 'https://open.kuaishou.com/platform'
                    : 'https://open-platform.devops.test.gifshow.com/platform';
                setTimeout(() => {
                    window.location.href = url;
                }, 3000);
            }
        });
    },
});
